import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { history } from '../../helpers'
import { LoadingContent } from '../../components'
import { listarMeusProjetos } from '../meusProjetos/redux/meusProjetosActions'
import {
  buscarContextoCompetitorGap,
  listarCompetitorGaps,
  buscarCompetitorGapDetalhe,
  limparCompetitorGapDetalhe,
  setCompetitorGapFiltroStatus
} from './redux/competitorgapActions'

import './competitorgap.scss'
import CompetitorGapCard from './components/competitorgapcard/competitorgapcard'

import { modalOpen } from '../../layout/redux/layoutActions'
import CompetitorGapDetailModal from './components/competitorgapdetailmodal/competitorgapdetailmodal'


//export default () => {
const CompetitorGap = () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { sistema, load } = useSelector(state => state.layoutState)
  const { listMeusProjetos } = useSelector(state => state.meusProjetosState)

  const {
    contexto,
    gaps,
    detalhe,
    filtroStatusId,
    loadingContexto,
    loadingLista,
    loadingDetalhe
  } = useSelector(state => state.competitorgapState)

  /*
  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)
  */
  const nls = useMemo(() => {
    return require(`./nls/${sistema.idioma}.json`)
    }, [sistema.idioma])

    const nlsPopup = useMemo(() => {
    return require(`../../layout/nlsPopup/${sistema.idioma}.json`)
    }, [sistema.idioma])




  const [validandoAcesso, setValidandoAcesso] = useState(true)
  const [acessoValidado, setAcessoValidado] = useState(false)

  const [gapSelecionado, setGapSelecionado] = useState(null)



  useEffect(() => {
    const validarAcessoECarregarContexto = async () => {
      if (acessoValidado) return
      try {
        setValidandoAcesso(true)

        let projetos = listMeusProjetos

        if (!projetos || projetos.length === 0) {
          projetos = await dispatch(listarMeusProjetos('', nlsPopup))
        }

        const projetoAtual = projetos?.find(
          p => String(p.idProjeto) === String(idProjetos)
        )

        const podeAcessarCompetitorGap =
          projetoAtual?.situacao === 'A' &&
          projetoAtual?.temEmpresaPdca === true

        if (!podeAcessarCompetitorGap) {
          history.push('/myprojects')
          return
        }

        const contextoResult = await dispatch(buscarContextoCompetitorGap(idProjetos))

        if (!contextoResult?.ok || contextoResult?.contexto?.empresaPdcaExiste !== true) {
          history.push('/myprojects')
          return
        }

        dispatch(setCompetitorGapFiltroStatus(1))

        await dispatch(listarCompetitorGaps({
          projetoId: Number(idProjetos),
          statusId: 1
        }))

        setAcessoValidado(true)
      } catch (error) {
        console.error('Erro ao validar acesso ao Competitor Gap:', error)
        history.push('/myprojects')
      } finally {
        setValidandoAcesso(false)
      }
    }

    validarAcessoECarregarContexto()
  }, [dispatch, idProjetos, sistema.idioma, listMeusProjetos, nlsPopup, acessoValidado])

  const handleSelecionarStatus = async statusId => {
    dispatch(setCompetitorGapFiltroStatus(statusId))

    await dispatch(listarCompetitorGaps({
      projetoId: Number(idProjetos),
      statusId
    }))
  }

  const handleAbrirDetalhe = async gap => {
    setGapSelecionado(gap)
    dispatch(limparCompetitorGapDetalhe())
    dispatch(modalOpen('competitorGapDetail'))

    await dispatch(buscarCompetitorGapDetalhe(gap.gapId))
    }


  if (validandoAcesso || loadingContexto || !acessoValidado) {
    return (
      <div
  className='box-competitor-gap'
  data-cy='page-competitorgaps'
>
  <div className='box-competitor-gap-content'>
          <LoadingContent
            show={!load}
            title={nls.loading || 'Carregando...'}
            height='calc(100vh - 150px)'
          >
            <div />
          </LoadingContent>
        </div>
      </div>
    )
  }

  return (
  <div
    className='box-competitor-gap'
    data-cy='page-competitorgaps'
  >
    <div className='box-competitor-gap-content'>
        <div className='box-competitor-gap-context'>
          <div className='box-competitor-gap-context-item'>
            <span className='box-competitor-gap-context-label'>
              {nls.project}:
            </span>

            <span className='box-competitor-gap-context-value'>
              {contexto?.projetoNome || '-'}
            </span>
          </div>

          <div className='box-competitor-gap-context-item'>
            <span className='box-competitor-gap-context-label'>
              {nls.company}:
            </span>

            <span className='box-competitor-gap-context-value'>
              {contexto?.empresaPdcaNome || '-'}
            </span>
          </div>
        </div>

        <h1 className='box-competitor-gap-title'>
          {nls.title}
        </h1>

        <div
  className='box-competitor-gap-filter'
  data-cy='competitorgaps-filter'
>
          <span className='box-competitor-gap-filter-label'>
            {nls.status}:
          </span>

          <label className='box-competitor-gap-radio'>
            <input
  data-cy='filter-status'
  data-cy-value='1'
  data-cy-selected={Number(filtroStatusId) === 1 ? 'true' : 'false'}
  type='radio'
  name='competitorGapStatus'
  value='1'
  checked={Number(filtroStatusId) === 1}
  onChange={() => handleSelecionarStatus(1)}
  disabled={loadingLista}
/>
            {' '}
            {nls.active}
          </label>

          <label className='box-competitor-gap-radio'>
            <input
  data-cy='filter-status'
  data-cy-value='2'
  data-cy-selected={Number(filtroStatusId) === 2 ? 'true' : 'false'}
  type='radio'
  name='competitorGapStatus'
  value='2'
  checked={Number(filtroStatusId) === 2}
  onChange={() => handleSelecionarStatus(2)}
  disabled={loadingLista}
/>
            {' '}
            {nls.inactive}
          </label>
        </div>


        <div
  className='box-competitor-gap-list'
  data-cy='competitorgaps-result'
>
            {loadingLista ? (
                <div
  className='box-competitor-gap-loading-list'
  data-cy='competitorgaps-loading'
>
                {nls.loading || 'Carregando...'}
                </div>
            ) : (
                <>
                {gaps?.length > 0 ? (
                    <div
  className='box-competitor-gap-cards'
  data-cy='competitorgaps-cards'
>
                    {gaps.map(gap => (
                        <CompetitorGapCard
                        key={gap.gapId}
                        gap={gap}
                        nls={nls}
                        onDetalhe={handleAbrirDetalhe}
                        />
                    ))}
                    </div>
                ) : (
                    <div
  className='box-competitor-gap-empty'
  data-cy='competitorgaps-empty'
>
  {nls.emptyList}
</div>
                )}
                </>
            )}
        </div>

        <CompetitorGapDetailModal
        gap={gapSelecionado}
        detalhe={detalhe}
        loadingDetalhe={loadingDetalhe}
        nls={nls}
        />


      </div>


      
    </div>
  )
}

export default CompetitorGap